import * as React from 'react'
import { Slide, List } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import DarkMode from '../Components/DarkMode/DarkMode'
import Language from '../Components/Language/Language'

interface Props {}
const Settings: React.FC<Props> = () => {
  return (
    <Slide direction={'left'} in={true} timeout={500}>
      <Container>
        <Box>
          <CssBaseline />
          <List sx={{ gap: '10px', display: 'grid' }}>
            <Language />
            <DarkMode />
          </List>
        </Box>
      </Container>
    </Slide>
  )
}
export default Settings
